export const componentFilters = {};

export const PAYMENT_STATUS = {
  OVERDUE: 'OVERDUE',
  NOT_PAID: 'CANCELLED',
  PAID: 'PAID',
};
